export interface TastingMenuItem {
  id: string;
  name: string;
  courses: number;
  priceINR: string;
  priceUSD: string;
  numericINR: number;
  numericUSD: number;
  badge: string;
  description: string;
  highlightDishes: string[];
  pairingPriceINR: string;
  pairingPriceUSD: string;
  image: string;
}

export interface PrivateDiningSalon {
  id: string;
  name: string;
  capacity: string;
  minSpendINR: string;
  minSpendUSD: string;
  numericINR: number;
  numericUSD: number;
  ambience: string;
  image: string;
  features: string[];
}

export const TASTING_MENUS: TastingMenuItem[] = [
  {
    id: "menu-degustation",
    name: "The 7-Course Signature Degustation",
    courses: 7,
    priceINR: "₹6,500 / Guest",
    priceUSD: "$85 / Guest",
    numericINR: 6500,
    numericUSD: 85,
    badge: "Executive Chef's Selection",
    description: "A harmonious progression through modern French-Asian culinary technique, showcasing dry-aged proteins, seasonal forage, and artisanal fermentation.",
    highlightDishes: [
      "Hokkaido Scallop Crudo with Calamansi & Oscietra Caviar",
      "Wood-Fired Morel Mushroom & Truffle Consommé",
      "Kagoshima A5 Wagyu Ribeye with Fermented Black Garlic",
      "Smoked Madagascar Vanilla Bean Soufflé"
    ],
    pairingPriceINR: "₹3,800 Grand Cru Pairing",
    pairingPriceUSD: "$50 Sommelier Flight",
    image: "https://images.unsplash.com/photo-1544025162-d76694265947?auto=format&fit=crop&w=1000&q=80"
  },
  {
    id: "menu-truffle-wagyu",
    name: "Prestige Truffle & Wagyu Reserve",
    courses: 9,
    priceINR: "₹9,800 / Guest",
    priceUSD: "$125 / Guest",
    numericINR: 9800,
    numericUSD: 125,
    badge: "Ultra Luxury Reserve",
    description: "An opulent multi-sensory journey centered around Perigord winter truffles, Brittany blue lobster, and vintage cellar reserves.",
    highlightDishes: [
      "Poached Blue Lobster with Coral Bisque & Sea Urchin",
      "Hand-Cut Tagliolini with 24-Month Parmigiano & Fresh Alba Truffle",
      "Slow-Smoked Duck Breast with Spiced Plum Gastrique",
      "Dark Valrhona 72% Chocolate Sphere with Gold Leaf & Cognac Flambé"
    ],
    pairingPriceINR: "₹5,500 Rare Vintage Pairing",
    pairingPriceUSD: "$70 Premier Cru Pairing",
    image: "https://images.unsplash.com/photo-1504674900247-0877df9cc836?auto=format&fit=crop&w=1000&q=80"
  },
  {
    id: "menu-botanical",
    name: "Flora: Botanical Heritage Tasting",
    courses: 6,
    priceINR: "₹5,200 / Guest",
    priceUSD: "$68 / Guest",
    numericINR: 5200,
    numericUSD: 68,
    badge: "Plant-Forward Gastronomy",
    description: "A hyper-seasonal celebration of farm-to-table botanicals, wild mushrooms, heirloom tubers, and wood-fired vegetable charcuterie.",
    highlightDishes: [
      "Heirloom Beet Tartare with Pickled Mustard Seed & Smoked Almonds",
      "Ember-Roasted King Oyster Mushroom with Aged Shoyu Glaze",
      "Charred Romanesco with Saffron Velouté & Pine Nut Praline",
      "Compressed Melon with Elderflower Infusion & Basil Granita"
    ],
    pairingPriceINR: "₹3,200 Biodynamic Wine Flight",
    pairingPriceUSD: "$42 Natural Wine Pairing",
    image: "https://images.unsplash.com/photo-1540420773420-3366772f4999?auto=format&fit=crop&w=1000&q=80"
  }
];

export const PRIVATE_DINING_SALONS: PrivateDiningSalon[] = [
  {
    id: "salon-cellar",
    name: "The Sommelier's Wine Vault",
    capacity: "Up to 12 Guests",
    minSpendINR: "₹75,000 Minimum Spend",
    minSpendUSD: "$950 Minimum Spend",
    numericINR: 75000,
    numericUSD: 950,
    ambience: "Subterranean limestone cellar encased by 2,400 vintage wine bottles and dedicated sommelier service.",
    image: "https://images.unsplash.com/photo-1510812431401-41d2bd2722f3?auto=format&fit=crop&w=1000&q=80",
    features: [
      "Private Master Sommelier Assigned",
      "Dedicated Acoustic Soundproofing",
      "Vintage Decanting & Cellar Access",
      "Bespoke 8-Course Customization"
    ]
  },
  {
    id: "salon-chef-table",
    name: "The Executive Chef's Counter",
    capacity: "Up to 8 Guests",
    minSpendINR: "₹60,000 Minimum Spend",
    minSpendUSD: "$780 Minimum Spend",
    numericINR: 60000,
    numericUSD: 780,
    ambience: "Direct front-row theater seating overlooking the open hearth and culinary brigade in live motion.",
    image: "https://images.unsplash.com/photo-1555396273-367ea4eb4db5?auto=format&fit=crop&w=1000&q=80",
    features: [
      "Interactive Plating by Head Chef",
      "Off-Menu Experimental Courses",
      "Signed Keepsake Tasting Menus",
      "Exclusive Caviar & Truffle Service"
    ]
  },
  {
    id: "salon-terrace",
    name: "The Skyline Glass Conservatory",
    capacity: "16 to 30 Guests",
    minSpendINR: "₹1,80,000 Minimum Spend",
    minSpendUSD: "$2,300 Minimum Spend",
    numericINR: 180000,
    numericUSD: 2300,
    ambience: "Rooftop botanical terrace with panoramic skyline views, private bar station, and outdoor cigar lounge.",
    image: "https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?auto=format&fit=crop&w=1000&q=80",
    features: [
      "Private Mixology & Champagne Bar",
      "Integrated AV & Presentation Setup",
      "Dedicated Service Butler Brigade",
      "Custom Flower & Place Card Decor"
    ]
  }
];

export const DINING_TIME_SLOTS = [
  "12:30 PM (Lunch)",
  "01:30 PM (Lunch)",
  "06:30 PM (First Dinner Sitting)",
  "07:15 PM (Prime Dinner Sitting)",
  "08:30 PM (Grand Dinner Sitting)",
  "09:15 PM (Late Dinner Sitting)"
];

export const DINING_AREAS = [
  "Main Dining Room (Elegance)",
  "The Sommelier's Wine Vault (Cellar)",
  "The Executive Chef's Counter (Kitchen View)",
  "The Skyline Glass Conservatory (Rooftop)"
];

export const DINING_OCCASIONS = [
  "Fine Dining Date / Romantic",
  "Corporate Dinner & Client Entertainment",
  "Anniversary or Birthday Celebration",
  "Private Tasting & Wine Pairing Event",
  "Family Gathering / Festive Banquet"
];
